<template>
    <header>
        <div id="prism_top"></div>
        <div id="prism_footer"></div>

        <div class="row my-4">
            <div class="col-4 logo">
                <img :src="require('@/assets/img/logo.png')" alt="Nave do Conhecimento" />
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'LayoutHeader',

    methods: {
        changeLanguage(language) {
            this.$ml.change(language)
        }
    },
}
</script>
